// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate_report stimulus controllerName

import { application } from "./application"

import EditableCellController from "./editable_cell_controller"
application.register("editable-cell", EditableCellController)

import SaveIndicatorController from "./save_indicator_controller"
application.register("save-indicator", SaveIndicatorController)

import Dropdown_controller from './dropdown_controller';
application.register("dropdown", Dropdown_controller)

import MobileMenuController from './mobile_menu_controller'
application.register("mobile-menu", MobileMenuController)

import ContractorSelectorController from './contractor_selector_controller'
application.register("contractor-selector", ContractorSelectorController)

import ModalController from './modal_controller';
application.register('modal', ModalController);

import PasswordVisibilityController from './password_visibility_controller'
application.register('password-visibility', PasswordVisibilityController);

import FileDropController from './file_drop_controller'
application.register('file-drop', FileDropController);

import DeviceCheckFilesController from './device_check_files_controller'
application.register('device-check-files', DeviceCheckFilesController);

import ReportPanelController from './report_panel_controller'
application.register('report-panel', ReportPanelController);

import DisableSubmitController from './disable_submit_controller'
application.register('disable-submit', DisableSubmitController);

import CustomerSelectController from './customer_select_controller'
application.register('customer-select', CustomerSelectController);

import BranchSelectController from './branch_select_controller'
application.register('branch-select', BranchSelectController);

import AddressFieldsController from './address_fields_controller'
application.register('address-fields', AddressFieldsController);

import TechnicianSelectorController from './technician_selector_controller'
application.register('technician-selector', TechnicianSelectorController);

import FaultsFormController from './faults_form_controller'
application.register('faults-form', FaultsFormController);

import PollingController from './polling_controller'
application.register('polling', PollingController);

import ClearErrorController from './clear_error_controller'
application.register('clear-error', ClearErrorController);

import SaveErrorNotifierController from './save_error_notifier_controller'
application.register('save-error-notifier', SaveErrorNotifierController);

import LabelFormController from './label_form_controller'
application.register('label-form', LabelFormController);

import DebouncedSearchController from './debounced_search_controller'
application.register('debounced-search', DebouncedSearchController);

import LoadingOverlayController from './loading_overlay_controller'
application.register('loading-overlay', LoadingOverlayController);

import RoomModalController from './room_modal_controller'
application.register('room-modal', RoomModalController);

import ResolvedRowController from './resolved_row_controller'
application.register('resolved-row', ResolvedRowController);

import KindSelectController from './kind_select_controller'
application.register('kind-select', KindSelectController);

import StickyColumnsController from './sticky_columns_controller'
application.register('sticky-columns', StickyColumnsController);
